export const env = "development"
export const url = getReprintEndpoint()

function getReprintEndpoint() {
  let url
  if (env === "production") {
  } else if (env === 'development') {
        url = 'https://stage.printversepro.com/bin'
    }
    else {
        url = 'http://localhost:9000/bin'

    }

    return url

}
